import useToastContext from '@contexts/ToastContext/hook';
import { PropsWithChildren, createContext, useEffect, useState } from 'react';
import { GetInvalidPixKeyResponse, PlatformUser } from '@interfaces/profile';
import { getPersonalData, getPlatformUserInvalidPixKeys } from '@api/profile';
import { InvalidPixKeyModal } from '@components/Profile/InvalidPixKeyModal/InvalidPixKeyModal';
import { ReviewProfileDialog } from '@components/Profile/ReviewProfileDialog/ReviewProfileDialog';
import { PlatformUserAddress } from '@interfaces/platformUserAddress/platformUserAddress';
import { findPlatformUserAddress } from '@api/platformUserAddress';

export const ProfileContext = createContext({});

type Props = PropsWithChildren;

export const ProfileContextProvider = (props: Props) => {
  const [invalidPixKeys, setInvalidPixKeys] = useState<
    GetInvalidPixKeyResponse[]
  >([]);
  const toast = useToastContext();
  const fetchInvalidPixKeys = async () => {
    try {
      const response = await getPlatformUserInvalidPixKeys();
      setInvalidPixKeys(response);
    } catch (err) {
      toast.handleError(
        err,
        'Ocorreu um erro ao buscar as chaves pix do usuário.',
      );
    }
  };
  useEffect(() => {
    fetchInvalidPixKeys();
  }, []);

  const [platformUser, setPlatformUser] = useState<PlatformUser>();
  const [address, setAddress] = useState<PlatformUserAddress>();
  const fetchProfile = async () => {
    try {
      const puResponse = await getPersonalData();
      setPlatformUser(puResponse);

      const addressResponse = await findPlatformUserAddress();
      setAddress(addressResponse);
    } catch (err) {
      toast.handleError(
        err,
        'Ocorreu um erro ao carregar os dados do usuário.',
      );
      setPlatformUser(undefined);
    }
  };
  useEffect(() => {
    fetchProfile();
  }, []);

  return (
    <ProfileContext.Provider value={{}}>
      <InvalidPixKeyModal invalidPixKeys={invalidPixKeys} />
      <ReviewProfileDialog
        platformUser={platformUser}
        platformUserAddress={address}
      />
      {props.children}
    </ProfileContext.Provider>
  );
};
